import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";

const IDLE_TIMEOUT = 1000 * 60 * 100; // ✅ 10 minutes

const IdleTimerComponent = () => {
  const navigate = useNavigate();

  const handleOnIdle = useCallback(() => {
    // 🔐 Clear all auth/session data
    sessionStorage.clear();
    localStorage.clear();

    // (optional) call backend logout API here

    alert("Session expired due to inactivity.");
    window.location.href = "/"; // redirect to login
  }, []);

  useIdleTimer({
    timeout: IDLE_TIMEOUT,
    onIdle: handleOnIdle,
    debounce: 500,
    crossTab: true,              // logout across browser tabs
    leaderElection: true,        // only one tab controls timer
    syncTimers: 200,             // keeps tabs in sync
  });

  return null; // nothing to render
};

export default IdleTimerComponent;
